import { createAction, props } from '@ngrx/store';
import { PowerBiExportRequest } from 'src/app/reporting/reports/models/powerbi-export-request.model';
import { PowerBiExportStatus } from 'src/app/reporting/reports/models/powerbi-export-status.model';

export enum PowerBiReportActionNames {
    EXPORT_POWERBI_REPORT = '[POWER BI REPORT] Export Power Bi Report',
    EXPORT_POWERBI_REPORT_SUCCESS = '[POWER BI REPORT] Export Power Bi Report Success',
    EXPORT_POWERBI_REPORT_FAIL = '[POWER BI REPORT] Export Power Bi Report Fail',
    EXPORT_POWERBI_REPORT_STATUS = '[POWER BI REPORT]  Get Power Bi Report Export Status',
    EXPORT_POWERBI_REPORT_STATUS_SUCCESS = '[POWER BI REPORT] Get Power Bi Report Export Status Success',
    EXPORT_POWERBI_REPORT_STATUS_FAIL = '[POWER BI REPORT] Get Power Bi Report Export Status Fail',
    CLEAR_POWERBI_REPORT = '[POWER BI REPORT] Clear Power Bi Report'
}

export const exportPowerBiReport = createAction(
    PowerBiReportActionNames.EXPORT_POWERBI_REPORT,
    props<{ id: number; requestModel: PowerBiExportRequest }>()
);
export const exportPowerBiReportSuccess = createAction(
    PowerBiReportActionNames.EXPORT_POWERBI_REPORT_SUCCESS,
    props<{ status: PowerBiExportStatus }>()
);
export const exportPowerBiReportFail = createAction(
    PowerBiReportActionNames.EXPORT_POWERBI_REPORT_FAIL,
    props<{ error: any }>()
);

export const getPowerBiReportExportStatus = createAction(
    PowerBiReportActionNames.EXPORT_POWERBI_REPORT_STATUS,
    props<{ id: number; exportId: string }>()
);
export const getPowerBiReportExportStatusSuccess = createAction(
    PowerBiReportActionNames.EXPORT_POWERBI_REPORT_STATUS_SUCCESS,
    props<{ status: PowerBiExportStatus }>()
);
export const getPowerBiReportExportStatusFail = createAction(
    PowerBiReportActionNames.EXPORT_POWERBI_REPORT_STATUS_FAIL,
    props<{ error: any }>()
);

export const clearPowerBiReport = createAction(PowerBiReportActionNames.CLEAR_POWERBI_REPORT);
